// src/pages/seller/Seller2Net/components/PropertyDetailsSection.js
import React, { useCallback } from "react";
import FloatingInput from "../../../../components/input/FloatingInput";
import FloatingNumber from "../../../../components/input/FloatingNumber";

const RadioGroup = ({ name, value, onChange, options }) => (
  <div className="frm-radio">
    {options.map((opt) => (
      <label key={opt.value}>
        <input
          type="radio"
          name={name}
          value={opt.value}
          checked={value === opt.value}
          onChange={() => onChange(opt.value)}
        />{" "}
        {opt.label}
      </label>
    ))}
  </div>
);

// const CommissionInput = ({ label, value, onChange }) => (
//   <div className="frm-field-c">
//     <label className="heading-d">{label}:</label>
//     <div className="form-group sign-of-percentage">
//       <FloatingNumber
//         type="text"
//         placeholder="0.00"
//         className="inpt-pla"
//         value={value}
//         onChange={(e) => onChange(e?.target?.value ?? "")}
//       />
//     </div>
//   </div>
// );

function PropertyDetailsSection({
  // ttbData,
  // formatCurrency,
  isCorrectProperty,
  setIsCorrectProperty,
  // isInitialLoad,
  // useAnnualPropertyTax,
  // setUseAnnualPropertyTax,
  salesPriceError,
  // useHomeWarranty, // unused but kept for compatibility
  formData,
  setFormData,
  handleCurrencyBlur,
  handleCalculate,
}) {
  // Memoize derived values for cleaner render
  // const taxAmount = useMemo(() => Number(ttbData?.taxAmount || 0), [ttbData]);
  // const sellerItem = useMemo(
  //   () =>
  //     formData?.paymentToBuyer?.find(
  //       (it) => (it?.key || "").toLowerCase() === "seller_broker_comp_pct"
  //     ) || {},
  //   [formData]
  // );
  // const buyerItem = useMemo(
  //   () =>
  //     formData?.paymentToBuyer?.find(
  //       (it) => (it?.key || "").toLowerCase() === "buyer_broker_comp_pct"
  //     ) || {},
  //   [formData]
  // );

  const handleSalesPriceChange = useCallback(
    (e) => setFormData((p) => ({ ...p, salesPrice: e.target.value })),
    [setFormData]
  );

  // const handleSellerCompChange = useCallback(
  //   (val) =>
  //     setFormData((p) => ({
  //       ...p,
  //       compensationMeta: {
  //         ...(p?.compensationMeta || {}),
  //         sellerBrokerCompensation: val,
  //       },
  //     })),
  //   [setFormData]
  // );

  // const handleBuyerCompChange = useCallback(
  //   (val) =>
  //     setFormData((p) => ({
  //       ...p,
  //       compensationMeta: {
  //         ...(p?.compensationMeta || {}),
  //         buyerBrokerCompensation: val,
  //       },
  //     })),
  //   [setFormData]
  // );

  const handleDateChange = useCallback(
    (e) =>
      setFormData((p) => ({
        ...p,
        loanInfoMeta: {
          ...p.loanInfoMeta,
          estimatedClosingDate: e.target.value,
        },
      })),
    [setFormData]
  );

  // if (!isInitialLoad) return null;

  return (
    <div className="property-detail-container">
      <div className="property-details-list">
        {/* ✅ Correct property question */}
        <div className="property-question">
          <div className="content-description">
            <p className="heading-d txtclr">Is this the correct property? </p>
          </div>
          <div className="form-value">
            <RadioGroup
              name="correctproperty"
              value={isCorrectProperty}
              onChange={setIsCorrectProperty}
              options={[
                { label: "Yes", value: true },
                { label: "No", value: false },
              ]}
            />
          </div>
        </div>

        {isCorrectProperty && (
          <>
            {/* ✅ Sales Price */}
            <div className="property-question p-t-20 m-t-20 border-top-sec">
              <div className="content-description">
                <p className="heading-f txtclr">Loan details</p>
              </div>
            </div>

            <div className="property-question m-t-20">
              <div className="content-description">
                <p className="heading-b txtclr">
                  What is the Estimated Appraised Value?
                </p>
              </div>
              <div className="form-value">
                <div className="form-group sign-of-amount">
                  <FloatingNumber
                    type="text"
                    name="salesPrice"
                    placeholder="0.00"
                    className="inpt-pla"
                    value={formData.salesPrice || ""}
                    onChange={handleSalesPriceChange}
                    onBlur={() => handleCurrencyBlur("salesPrice")}
                  />
                  {salesPriceError && (
                    <div className="text-red-600 text-sm mt-1">
                      {salesPriceError}
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* ✅ Agent Commission Split 
            <div className="property-question p-t-20 m-t-20 border-top-sec">
              <div className="content-description">
                <p className="heading-f txtclr">Agent Commission Split</p>
              </div>
            </div>

            <div className="property-question m-t-20">
              <div className="lable-wrap">
                <CommissionInput
                  label={sellerItem?.label || "Seller Broker Compensation"}
                  value={
                    sellerItem?.rate ??
                    formData?.compensationMeta?.sellerBrokerCompensation ??
                    ""
                  }
                  onChange={handleSellerCompChange}
                />
                <CommissionInput
                  label={buyerItem?.label || "Buyer Broker Compensation"}
                  value={
                    buyerItem?.rate ??
                    formData?.compensationMeta?.buyerBrokerCompensation ??
                    ""
                  }
                  onChange={handleBuyerCompChange}
                />
              </div>
            </div>*/}

            {/* ✅ Closing date */}
            <div className="property-question p-t-20 m-t-20 border-top-sec">
              <div className="content-description">
                <p className="heading-f txtclr">Closing date</p>
              </div>
            </div>

            <div className="property-question m-t-20">
              <div className="content-description">
                <p className="heading-b txtclr">
                  What is the Estimated Closing Date:
                </p>
              </div>
              <div className="form-value">
                <div className="form-group">
                  <FloatingInput
                    type="date"
                    name="estimatedClosingDate"
                    label=""
                    placeholder="MM/DD/YYYY"
                    className="inpt-pla"
                    value={formData.loanInfoMeta.estimatedClosingDate || ""}
                    onChange={handleDateChange}
                  />
                </div>
              </div>
            </div>

            {/* ✅ Calculate Button */}
            <div className="middle-content-calc calculate-btn">
              <button
                className="submit-btn btn-bg inpt-btn"
                onClick={handleCalculate}
              >
                Calculate
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default React.memo(PropertyDetailsSection);
